import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NPOSignupForm } from "@/components/NPOSignupForm";
import { useToast } from "@/components/ui/use-toast";
import SEO from '@/components/SEO';

const NPOProfileCompletion = ({ session, profile }: { session: any; profile: any }) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [metadata, setMetaData] = useState<any>(null);

  useEffect(() => {
    const checkAuth = async () => {
      console.log(profile);
      try {
        setMetaData(profile);

        if (!session) {
          navigate("/login");
          return;
        }

        if (profile.user_type !== "nonprofit") {
          return navigate("/unauthorized");
        }
      } catch (error: any) {
        console.error("Auth check error:", error);
        toast({
          title: "Error",
          description: error.message,
          variant: "destructive",
        });
      }
    };

    checkAuth();
  }, [session, profile]);

  if (!session) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title="Complete NPO Profile" 
        description="Complete your nonprofit organization profile to start creating volunteer opportunities and connecting with corporate partners."
        noindex={true}
      />
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold mb-8">Complete Your Profile</h1>
            <p className="text-gray-600 mb-8">
              Please complete your organization's profile to continue. This information helps us
              better understand your organization and connect you with suitable opportunities.
            </p>
            <NPOSignupForm session={session} profile={profile} initialData={metadata} />
          </div>
        </div>
      </div>
    </>
  );
};

export default NPOProfileCompletion;